import { render, staticRenderFns } from "./awsElasticBlockStore.vue?vue&type=template&id=390a08cc&"
import script from "./awsElasticBlockStore.vue?vue&type=script&lang=js&"
export * from "./awsElasticBlockStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports